<template>
    <div id="page_Home" v-scroll-spy>
        
        <Forte data-aos="fade-up"></Forte>
        <OurForte  data-aos="fade-up"></OurForte>
        <Experience  data-aos="fade-up"></Experience>
        <Achievements data-aos="fade-up"></Achievements>
        <Glory data-aos="fade-up"></Glory>
        <Gallery data-aos="fade-up"></Gallery>
        <Contact data-aos="fade-up"></Contact>

    </div>
</template>

<script>
import Forte from './Forte';
import OurForte from './OurForte';
import Experience from './Experience';
import Achievements from './Achievements';
import Glory from './Glory';
import Gallery from './Gallery';
import Contact from './Contact';

export default {
    name: 'Home',
    props: ['scrollPos'],
    components: {
        Forte,
        OurForte,
        Experience,
        Achievements,
        Glory,
        Gallery,
        Contact
    },
}
</script>

<style  scoped>

</style>